import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import HomeUA from "./pages/HomeUA.jsx";
import HomeUKR from "./pages/HomeUKR.jsx";
import HomeEN from "./pages/HomeEN.jsx";
import ContactUA from "./pages/ContactUA.jsx";
import ContactEN from "./pages/ContactEN.jsx";
import CareersUA from "./pages/CareersUA.jsx";
import CareersEN from "./pages/CareersEN.jsx";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage.jsx";
import CookiePolicyPage from "./pages/CookiePolicyPage.jsx";
import ReturnsPolicyPage from "./pages/ReturnsPolicyPage.jsx";
import TermsOfServicePage from "./pages/TermsOfServicePage.jsx";
import AcceptableUsePolicyPage from "./pages/AcceptableUsePolicyPage.jsx";
import CompanyDetailsPage from "./pages/CompanyDetailsPage.jsx";

function Layout({ children, showLayout = true }) {
  return (
    <div className="min-h-screen">
      {showLayout && <Navbar />}
      {children}
      {showLayout && <Footer />}
    </div>
  );
}

// In production, CloudFront Function handles geo-redirect on /
// In dev, just redirect to /en as fallback
function RootRedirect() {
  return <Navigate to="/en" replace />;
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/en" element={<Layout showLayout={false}><HomeEN /></Layout>} />
          <Route path="/ua" element={<Layout showLayout={false}><HomeUA /></Layout>} />
          <Route path="/ukr" element={<Layout showLayout={false}><HomeUKR /></Layout>} />

          {/* Localized pages */}
          <Route path="/ua/contact" element={<Layout showLayout={false}><ContactUA /></Layout>} />
          <Route path="/en/contact" element={<Layout showLayout={false}><ContactEN /></Layout>} />
          <Route path="/ua/careers" element={<Layout showLayout={false}><CareersUA /></Layout>} />
          <Route path="/en/careers" element={<Layout showLayout={false}><CareersEN /></Layout>} />

          {/* Redirects for localized pricing/features to home page sections */}
          <Route path="/ua/pricing" element={<Navigate to="/ua#pricing" replace />} />
          <Route path="/en/pricing" element={<Navigate to="/en#pricing" replace />} />
          <Route path="/ua/features" element={<Navigate to="/ua#features" replace />} />
          <Route path="/en/features" element={<Navigate to="/en#features" replace />} />

          {/* Legacy routes redirect to localized versions */}
          <Route path="/features" element={<Navigate to="/en#features" replace />} />
          <Route path="/pricing" element={<Navigate to="/en#pricing" replace />} />
          <Route path="/contact" element={<Navigate to="/en/contact" replace />} />
          <Route path="/careers" element={<Navigate to="/en/careers" replace />} />

          {/* Legal/policy pages */}
          <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
          <Route path="/cookie" element={<Layout><CookiePolicyPage /></Layout>} />
          <Route path="/returns" element={<Layout><ReturnsPolicyPage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsOfServicePage /></Layout>} />
          <Route path="/acceptable-use" element={<Layout><AcceptableUsePolicyPage /></Layout>} />
          <Route path="/company" element={<Layout><CompanyDetailsPage /></Layout>} />

          {/* Catch-all */}
          <Route path="*" element={<Layout showLayout={false}><NotFound /></Layout>} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
